import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SobreNosotros.css';
import { Contactanos } from '../shared/Contactanos';
import CustomQR from '../shared/CustomQR';

export const SobreNosotros = () => {
  const navigate = useNavigate(); // Inicializamos useNavigate

  // Desplazarse al inicio al cargar el componente
     useEffect(() => {
      window.scrollTo(0, 0);
    }, []); // Dependencia vacía asegura que se ejecute solo una vez al montar

  const handleRegisterSalonClick = () => {
    // Redirige al usuario a la página de inicio
    navigate('/inicio');
  };

  return (
    <div className="sobre-nosotros-container">
      <h1>¿Quiénes somos?</h1>
      <p>
        Somos un equipo apasionados por facilitar la planificación de eventos. Nuestra misión es ofrecer una plataforma intuitiva que permita a nuestros clientes encontrar el salón perfecto para su celebración, ya sea una boda, un cumpleaños, un evento corporativo o cualquier ocasión especial. Nos inspiró la necesidad de contar con un lugar donde los clientes pudieran visualizar todos los detalles de los salones y los paquetes disponibles, de manera clara y sencilla, sin tener que hacer llamadas ni visitar cada lugar personalmente.
      </p>
      <p>
        Con formación en ingeniería en sistemas computacionales y una amplia experiencia en desarrollo de tecnologías, nos sentimos completamente preparados para ofrecer una solución eficiente y moderna que te ahorre tiempo y esfuerzo. Sabemos lo importante que es tener todo bajo control al momento de organizar un evento, y por eso nos hemos enfocado en crear una plataforma que te permita comparar y elegir el salón ideal para ti, con toda la información al alcance de tu mano.
      </p>

      <h2>Misión</h2>
      <p>
        Nuestra misión es ofrecerte los mejores espacios para tus eventos, para que cada celebración sea única e inolvidable. Queremos que tu experiencia sea lo más fácil posible, ayudándote a encontrar el lugar perfecto para tu celebración, sin complicaciones.
      </p>

      <h2>Visión</h2>
      <p>
        Queremos ser tu plataforma preferida y el aliado perfecto para la organización de eventos. A largo plazo, planeamos ofrecer no solo salones, sino también servicios complementarios que te ayuden a crear eventos únicos y personalizados.
      </p>

      <h2>Valores</h2>
      <ul>
        <li><strong>Ahorro de Tiempo:</strong> Hacemos que la planificación de tu evento sea más rápida y sencilla. Con nuestra plataforma intuitiva, accede a toda la información de salones y paquetes sin necesidad de llamadas ni visitas físicas.</li>
        <li><strong>Transparencia y honestidad:</strong> Queremos que tomes decisiones con total confianza, por eso toda la información sobre los salones y los paquetes es clara y detallada.</li>
        <li><strong>Compromiso con la calidad:</strong> Nos aseguramos de ofrecerte las mejores opciones para que tu evento sea todo un éxito. Cada espacio y paquete ha sido seleccionado pensando en tu satisfacción.</li>
        <li><strong>Flexibilidad:</strong> Sabemos que cada evento es único, por lo que nuestros paquetes son personalizables y adaptados a tus necesidades.</li>
      </ul>

      <h2>¿Qué nos hace diferentes?</h2>
      <p>
        Lo que nos hace únicos es nuestra plataforma fácil de usar, que te permite visualizar todos los salones disponibles con información detallada sobre los paquetes que incluyen. A diferencia de otros servicios, aquí no solo te mostramos los espacios, sino que te damos la posibilidad de ver exactamente lo que incluye cada opción, para que puedas tomar decisiones informadas.
      </p>

       {/* Sección para Clientes */}
       <div className="section-client">
        <h2>¿Estás buscando el lugar perfecto para tu evento?</h2>
        <p>
          En nuestra plataforma podrás explorar una variedad de salones para todo tipo de
          eventos: bodas, cumpleaños, eventos corporativos y mucho más. Compara opciones,
          visualiza paquetes detallados y reserva el espacio ideal para ti, ¡todo en un solo
          lugar!
        </p>
        <button onClick={handleRegisterSalonClick}>
          Encuentra tu salón
        </button>
      </div>

        <Contactanos />
      
    </div>
    
  );
}




// import React from "react";
// import "./Introduction.css"; // Para estilizar el componente

// const Introduction = () => {
//   return (
//     <div className="intro-container">
//       {/* Sección para Clientes */}
//       <div className="section-client">
//         <h2>¿Estás buscando el lugar perfecto para tu evento?</h2>
//         <p>
//           En nuestra plataforma podrás explorar una variedad de salones para todo tipo de
//           eventos: bodas, cumpleaños, eventos corporativos y mucho más. Compara opciones,
//           visualiza paquetes detallados y reserva el espacio ideal para ti, ¡todo en un solo
//           lugar!
//         </p>
//         <button onClick={() => console.log("Ir a buscar salones")}>
//           Encuentra tu salón
//         </button>
//       </div>

//       {/* Sección para Dueños de Salones */}
//       <div className="section-owner">
//         <h2>¿Eres dueño de un salón?</h2>
//         <p>
//           Únete a nuestra plataforma y llega a miles de clientes que buscan el espacio perfecto
//           para su evento. Publica tu salón, muestra tus paquetes y facilita las reservas. ¡Haz crecer
//           tu negocio con nosotros!
//         </p>
//         <button onClick={() => console.log("Ir a registrar salón")}>
//           Registra tu salón
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Introduction;


// .intro-container {
//   display: flex;
//   justify-content: space-between;
//   padding: 50px;
//   gap: 20px;
// }

// .section-client, .section-owner {
//   width: 45%;
//   padding: 20px;
//   background-color: #f7f7f7;
//   border-radius: 10px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
// }

// h2 {
//   font-size: 1.5rem;
//   color: #333;
// }

// p {
//   font-size: 1rem;
//   color: #666;
// }

// button {
//   padding: 10px 20px;
//   margin-top: 20px;
//   background-color: #3498db;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   transition: background-color 0.3s ease;
// }

// button:hover {
//   background-color: #2980b9;
// }
